var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"add-li-style grid-col-12 margin-top-2 tablet:margin-top-0",class:[_vm.data.fields.styleInstructions, _vm.getMediumWidth]},[_c('div',{staticClass:"cgi-card padding-x-3 shadow-2 text-bold",class:_vm.getSmallWidth},[_c('rich-text-renderer',{attrs:{"data":_vm.data.fields.cardBody}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }